/* eslint-disable react-hooks/exhaustive-deps */
// src/App.js

import CitySearch from './components/CitySearch';
import CityEventsChart from './components/CityEventsChart';
import EventsGenreChart from './components/EventGenresChart';
import EventList from './components/EventList';
import NumberOfEvents from './components/NumberOfEvents';
import './App.css';
import { useEffect, useState } from 'react';
import { extractLocations, getEvents } from './api';
import { InfoAlert, WarningAlert } from './components/Alert';
import { ErrorAlert } from './components/Alert';

const App = () => {
  const [events, setEvents] = useState([]);
  const [currentNOE, setCurrentNOE] = useState([32]);
  const [allLocations, setAllLocations] = useState([]);
  const [currentCity, setCurrentCity] = useState("See all cities");
  const [infoAlert, setInfoAlert] = useState("");
  const [errorAlert, setErrorAlert] = useState("");
  const [warningAlert, setWarningAlert] =useState("");

  const fetchData = async () => {
    const allEvents = await getEvents();
    const filteredEvents = currentCity === "See all cities" ?
      allEvents :
      allEvents.filter(event => event.location === currentCity);
    const currentEvents = await filteredEvents.slice(0, currentNOE)
    setEvents(currentEvents);
    setAllLocations(extractLocations(allEvents));
  }

  useEffect(() => {
    if (navigator.onLine) {
      setWarningAlert("")
    } else {
      setWarningAlert("You are offline. Events data may be outdated.")
    }
    fetchData();
  }, [currentCity, currentNOE]);

 return ( 
   <div className="App">
      <h1>Meet App</h1>
      <p>Find events in nearby cities</p>
     <div className="alerts-container">
        {infoAlert.length ? <InfoAlert text={infoAlert}/> : null}
        {errorAlert.length ? <ErrorAlert text={errorAlert}/> : null}
        {warningAlert.length ? <WarningAlert text={warningAlert}/> : null}
      </div>
     <CitySearch 
        allLocations={allLocations} 
        setCurrentCity={setCurrentCity} 
        setInfoAlert={setInfoAlert} />
     <NumberOfEvents 
        setCurrentNOE={setCurrentNOE}
        setErrorAlert={setErrorAlert}/>
    <div className="charts-container">
      <EventsGenreChart
        events={events} />
      <CityEventsChart 
        allLocations={allLocations} 
        events={events} />
    </div>
     <EventList events={events}/>
   </div>
 );
}

export default App;